export default __webpack_public_path__ + "static/media/ic_TarjetaRipley.9191a3fe.svg";